import { selectCurrentHotelName } from 'accessors'
import TextArea from 'features/ManageCampaigns/TextArea'
import { TextPreview, TextPreviewBubble } from 'features/ManageCampaigns/TextPreview'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import styles from './EditStepDialog.module.scss'

const REQUIRED_TAG_IDS = ['__inviteLink__']
const OPTIONAL_TAG_IDS = ['__guestName__', '__hotelName__']

function getMessageTags(hotelName) {
  return [
    {
      id: '__guestName__',
      display: 'firstName',
      code: '@[firstName](__guestName__)',
      length: 8
    },
    {
      id: '__hotelName__',
      display: 'hotelName',
      code: '@[hotelName](__hotelName__)',
      length: (hotelName || 'hotelName').length
    },
    {
      id: '__inviteLink__',
      display: 'inviteLink',
      code: '@[inviteLink](__inviteLink__)',
      length: 24
    }
  ]
}

function TextMessageStep({ messageTemplate, setMessageTemplate }) {
  const hotelName = useSelector(selectCurrentHotelName)

  return (
    <div className={styles.textMessageStep} data-testid="ota-buster-text-step">
      <p className={styles.description}>
        Text message sent alongside email when the guest has a mobile number on file. Saved
        as a draft until you launch the campaign.
      </p>

      <div className={styles.textEditorLayout}>
        <TextArea
          value={messageTemplate || ''}
          handleChange={setMessageTemplate}
          baseTags={getMessageTags(hotelName)}
          requiredTagIds={REQUIRED_TAG_IDS}
          optionalTagIds={OPTIONAL_TAG_IDS}
        />

        <TextPreview>
          <TextPreviewBubble
            text={messageTemplate}
            preferShortLink
            defaultData={{
              userName: 'Joe',
              hotelName
            }}
          />
        </TextPreview>
      </div>
    </div>
  )
}

TextMessageStep.propTypes = {
  messageTemplate: PropTypes.string,
  setMessageTemplate: PropTypes.func.isRequired
}

export default TextMessageStep
